import React, { useState } from 'react';
import { useSelector } from 'react-redux';

/**
 * Floating Action Button — contact support shortcut.
 * Only shown to passengers and drivers on mobile (lg: hidden, because
 * the sidebar already shows the contact block on desktop).
 */
const SupportFAB = () => {
  const { user } = useSelector((state) => state.auth);
  const [open, setOpen] = useState(false);

  // Only relevant for passengers & drivers
  if (user?.role !== 'passenger' && user?.role !== 'driver') return null;

  return (
    <div className="lg:hidden fixed bottom-6 right-5 z-40 flex flex-col items-end gap-3">
      {/* Expanded options */}
      {open && (
        <>
          {/* Email */}
          <a
            href="mailto:reservation@ifesteimo.com"
            className="flex items-center gap-2 bg-white shadow-lg rounded-full pl-3 pr-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 active:bg-gray-100 transition-colors animate-fade-in"
            onClick={() => setOpen(false)}
          >
            <span className="w-7 h-7 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
              <svg className="w-3.5 h-3.5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </span>
            reservation@ifesteimo.com
          </a>

          {/* Call */}
          <a
            href="tel:+13109514000"
            className="flex items-center gap-2 bg-white shadow-lg rounded-full pl-3 pr-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 active:bg-gray-100 transition-colors animate-fade-in"
            onClick={() => setOpen(false)}
          >
            <span className="w-7 h-7 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
              <svg className="w-3.5 h-3.5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
            </span>
            +1-310-951-4000
          </a>
        </>
      )}

      {/* FAB toggle button */}
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? 'Close support menu' : 'Contact support'}
        className={`w-13 h-13 w-[52px] h-[52px] rounded-full shadow-lg flex items-center justify-center transition-all duration-200 ${
          open
            ? 'bg-gray-700 text-white rotate-45'
            : 'bg-luxury-gold text-white hover:bg-yellow-500 active:bg-yellow-600'
        }`}
      >
        {open ? (
          /* × when open */
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
          </svg>
        ) : (
          /* headset icon when closed */
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 5.636A9 9 0 015.636 18.364M15 11a3 3 0 11-6 0 3 3 0 016 0zM3 11a9 9 0 0118 0v4a2 2 0 01-2 2h-1a2 2 0 01-2-2v-2a2 2 0 012-2h.5A6.5 6.5 0 007.5 9H7a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-4z" />
          </svg>
        )}
      </button>
    </div>
  );
};

export default SupportFAB;
